import AppModel from "models/AppModel";
import DataEntryModule from "lib/dataentry/DataEntryModule";
import { ModalLayout } from "../modal/ModalLayout";
import PropTypes from "prop-types";
import React from "react";
import { backboneConnect } from "lib/common/hoc/BackboneReact/backboneConnect";

export class RecordBrowserModule extends React.Component {
    render() {
        const {
            deModel,
            app,
            title,
            triggerClose,
            view,
        } = this.props;

        const modalOptions = {
            size: "modal-xlg",
            class: "record-browser",
            title: `${title} Browser`
        };

        const dem = new DataEntryModule({
            model: deModel,
            application: app,
            searchOnRender: true,
        });

        // this is retarded. holy cow is it dumb. :)
        if (view != null) view.on("before:close", () => dem.close());

        return (
            <ModalLayout
                modalOptions={modalOptions}
                triggerClose={triggerClose}
                moduleRef={dem}
            />
        );
    }
}

RecordBrowserModule.propTypes = {
    deModel: PropTypes.instanceOf(AppModel).isRequired,
    app: PropTypes.instanceOf(Backbone.Marionette.Application).isRequired,
    triggerClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    view: PropTypes.instanceOf(Backbone.Marionette.View)
};

const config = props => ({
    triggerClose: () => {
        props.view.trigger("close");
    }
});

export const BackboneRecordBrowserModule = backboneConnect(config)(RecordBrowserModule);



// WEBPACK FOOTER //
// ./app/lib/recordBrowser/RecordBrowserModule.js